<template>
  <div class="product-details">
    <EsHeaderView />
    <div class="app-container contain" v-loading="loading">
      <div class="product-details-contain">
        <!-- <EsProductInfo :id="id" /> -->
        <div class="product-info" v-loading="loading" v-if="show">
          <div class="product-info-content flex-start">
            <div class="product-info-left">
              <vue-photo-zoom-pro :out-zoomer="true">
                <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop"
                  @slideChange="onSlideChange()" @mouseenter.native="mouseEnter" @mouseleave.native="mouseLeave">
                  <swiper-slide v-for="(item, index) in obj.goodsImages" :key="index">
                    <!-- <img :src="item.large" alt="" /> -->
                    <img-preview :url="$getImageUrl(item.large)" />
                  </swiper-slide>
                </swiper>
                <template slot="zoomer">
                  <img-zoomer v-if="obj && obj.goodsImages && obj.goodsImages.length > 0"
                    :url="$getImageUrl(obj.goodsImages[curIndex].large)"></img-zoomer>
                </template>
              </vue-photo-zoom-pro>
              <swiper class="swiper gallery-thumbs" :options="swiperOptionTop.thumbs.swiper" ref="swiperThumbs">
                <swiper-slide v-for="(item, index) in obj.goodsImages ? obj.goodsImages : productImgs" :key="index"
                  @click.native="change(index)" :class="index == curIndex ? 'active' : ''">
                  <img :src="$getImageUrl(item.thumbnail)" alt="" />
                </swiper-slide>
              </swiper>
            </div>
            <div class="product-info-right">
              <h1 class="product-info-right-title">
                {{ obj.name }}
              </h1>
              <div class="product-info-right-info">
                <div class="product-info-right-info-top flex-between">
                  <div class="product-info-right-info-price flex-start">
                    <h2>{{ $t("message.home.retailPrice" /**零售价 */) }}</h2>
                    <span class="price">
                      {{ sku.price }}
                      <!-- ${{
                  numberFormatFn(
                   this.price ??  productDetails.discountPrice ?? productDetails.sellingPrice
                  )
                }} -->
                    </span>
                  </div>
                  <div class="product-info-right-info-price del flex-start"
                    v-if="![null, undefined].includes(obj.price)">
                    <h2>{{ $t("message.home.originPrice" /** 原价*/) }}</h2>
                    <span class="price">${{ obj.marketPrice }}</span>
                  </div>
                  <div class="product-info-right-info-tool flex-start">
                    <!-- <div class="product-info-right-info-tool-item flex-start" @click="showServiceDialog">
                      <i class="el-icon-service" style="color: var(--color-main); font-size: 20px"></i>
                      <span v-if="itemname == 'FamilyMart'">{{ $t("message.home.联系商家") }}</span>
                      <span v-else>{{ $t("message.home.service" /**客服 */) }}</span>
                    </div> -->
                    <div class="product-info-right-info-tool-item flex-start" @click="goods_share">
                      <img :src="require('@/assets/image/goods-share.png')" width="20" height="18" />
                      <!-- <i class="el-icon-share" /> -->
                      <span>分享</span>
                    </div>
                    <div class="product-info-right-info-tool-item flex-start" @click="goods_favorite_add">
                      <!-- <img :src="require('@/assets/image/Star.png')" alt="Star" /> -->
                      <i class="el-icon-star-off" />
                      <span>{{ $t("message.home.collect" /**收藏 */) }}</span>
                    </div>
                  </div>
                </div>

                <div class="product-info-right-info-des">
                  <div class="product-info-right-info-des-item flex-start">
                    <div>
                      <span style="margin-right: 5px">{{
                        $t("message.home.sold" /**销售量 */)
                      }}</span>
                      <span>{{ obj.sales }}</span>
                    </div>
                    <!-- <div>
                      <span style="margin-right: 5px">{{
                        $t("message.home.pageviews" /**浏览量 */)
                      }}</span>
                      <span>{{ productDetails.viewsNum }}</span>
                    </div> -->
                  </div>
                  <!-- <div class="product-info-right-info-des-item flex-start">
                    <span class="label-title">
                      {{ $t("message.home.goodsShip") }}
                    </span>
                    <span>{{ $t("message.home.goodsShipTips") }}</span>
                  </div> -->
                  <div class="product-info-right-info-des-item flex-start">
                    <span class="label-title">
                      {{ $t("message.home.goodsFreight") }}
                    </span>
                    <div class="freight-tips">
                      <p>
                        {{ obj.weight }}
                      </p>
                      <el-tooltip effect="dark" placement="top">
                        <div slot="content">
                          <p style="line-height: 18px">
                            {{ $t("message.home.goodsFreightTips1") }}
                          </p>
                          <p style="line-height: 18px">
                            {{ $t("message.home.goodsFreightTips2") }}
                          </p>
                          <p style="line-height: 18px">
                            {{ $t("message.home.goodsFreightTips3") }}
                          </p>
                        </div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="product-info-right-info-des-item flex-start">
                    <span class="label-title">
                      {{ $t("message.home.quantity" /**數量 */) }}
                    </span>
                    <el-input-number @blur="inputNumBlur" v-model="formData.quantity" :min=1 :max="maxNum" />
                  </div>
                  <div v-if="obj.specificationItems && obj.specificationItems.length">
                    <div class="product-info-right-info-des-item flex-start product-attr"
                      v-for="(item, index) in obj.specificationItems" :key="index">
                      <span class="label-title sku-titile">
                        {{ item.name }}
                      </span>



                      <!-- <div v-if="item.entries" class="attr-container">
                        <div v-for="(itm, idx) in item.entries" :key="idx"
                          :style="itm.isSelected ? 'display: block' : 'display:none'">
                          <div @click="skuShowTab(index, idx, itm)"
                            :class="idxs[index] == idx ? 'attr-item active' : 'attr-item'">
                            <div class="attr-img">
                              {{ itm.value }} -->
                      <!-- <img src="@/assets/image/Star.png" alt="" /> -->
                      <!-- </div>
                          </div>
                        </div>
                      </div> -->


                      <div v-if="item.entries">
                        <div v-for="(itm, idx) in item.entries" :key="idx"
                          :style="itm.isSelected ? 'display: block;float: left;margin-right: 20px;' : 'display:none;float: left;'">
                          <div @click="skuShowTab(index, idx, itm)"
                            :class="idxs[index] == idx ? 'attr-item active' : 'attr-item'">
                            <div class="attr-img">
                              {{ itm.value }}
                              <!-- <img src="@/assets/image/Star.png" alt="" /> -->
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- <el-select @change="(v) => changeGoodAttr(item.attrId, v)" :value="goodsAttrObj[item.attrId]"
                        :placeholder="`${$t('message.home.Opt')}${item.attrName}`" >
                        <el-option :value="attrItem.attrValueId" :label="attrItem.name"
                          v-for="attrItem in item.entries" :key="attrItem.value" >
                        </el-option>
                      </el-select> -->
                    </div>
                  </div>

                  <!-- <div class="product-info-right-info-des-item flex-start">
                    <span class="label-title">
                      {{ $t("message.home.totalPrice" /**总价 */) }}
                    </span>
                    <p>
                      <span class="price">${{ totalPrice }}</span>
                      <span class="del-line">Total Price: $56.12</span>
                    </p>
                  </div> -->
                </div>
                <div class="product-info-right-info-buy">
                  <el-button type="primary" @click="buy_handler">
                    {{ $t("message.home.buyNow" /**立即购买 */) }}
                  </el-button>
                  <div class="addcart flex-start" @click="cart_add_handler">
                    <span>
                      {{ $t("message.home.addCart" /** 添加购物车*/) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <EsOnlineServiceView v-model="showOnlieService" />
        </div>
        <!------------------------------>

        <!-- <EsProductDescription /> -->
        <!-- <div class="product-description" v-if="productDetails.des">
          <h1 class="title1">
            {{ this.$t("message.home.productDescription" /**商品描述 */) }}
          </h1>
          <p v-html="productDetails.des"></p>
        </div> -->


        <!-- <EsProductComment /> -->


        <div class="product-comment" v-if="reviews && reviews.length">
          <div class="p-header">
            <div class="title1">
              {{ this.$t("message.home.userEvaluation" /**用户评价 */) }}
              <span v-if="reviews && reviews.length">({{ reviews.length || 0 }})</span>

            </div>
            <div style="display: flex; flex-direction: row">
              <div v-for="item in Object.keys(categoryNum)" @click="onEvaluationClick(item)" class="button"
                :class="item === evaluationTypeKey ? 'active' : ''" :key="item">
                {{ categoryNum[item].text }}({{ categoryNum[item].num }})
              </div>
            </div>
          </div>
          <div class="product-comment-content" v-loading="loading" style="padding-top: 10px">
            <div v-for="(item, index) in reviews" :key="index" class="product-comment-item">
              <div class="product-comment-top flex-start">
                <div class="userInfo">
                  <img :src="require(`@/assets/image/avatar/${item.avatar || Math.floor(Math.random() * 20)
                    }.png`)
                    " alt="User" />
                  <div>{{ item.memberName }}</div>
                </div>
              </div>
              <div class="rate">
                <div class="rate-box">
                  <el-rate disabled :value="item.rating"></el-rate>
                  <span style="color: var(--color-main); font-size: 12px">{{
                    $t("message.home.订单已完成")
                  }}</span>
                </div>
              </div>
              <!-- <div v-if="item.attributes" class="attrbox">
          <div v-for="(i, d) in item.attributes" :key="d" class="attr">
            <div v-if="i.attrName">
              <span>{{ i.attrName }}</span
              >:<span>{{ i.attrValue }}</span>
            </div>
          </div>
        </div> -->
              <p class="product-comment-text">
                {{ item.content }}
              </p>
              <div>
                <el-image class="evaluation-img" v-for="url in evaluationImages[index]" :src="$getImageUrl(url)" :key="url"
                  :preview-src-list="evaluationImages[index].map(u => $getImageUrl(u))">
                </el-image>
              </div>
              <span class="eval-time"><span
                  v-if="item.countryName && itemname !== 'Inchoi' && itemname !== 'Green Mall'">{{
                    item.countryName }}&nbsp;>>&nbsp; </span>{{ $formatZoneDate(item.evaluationTime) }}</span>
            </div>
          </div>
          <div>
            <el-empty :description="$t('message.home.noComments')"></el-empty>
          </div>
          <div class="product-comment-pagination" v-if="total > 5">
            <el-pagination background layout="prev,next" class="es-pagination" :current-page="pageNum"
              :page-size="pageSize" :total="total" :prev-text="$t('message.home.prevPage')"
              :next-text="$t('message.home.nextPage')" @current-change="currentChange" />
          </div>
        </div>



        <!-- <EsProductDetailsInfo /> -->

        <div v-if="obj.introduction !== null">
          <div v-if="obj.introduction !== '<p><br></p>'">
            <div class="product-details-content" v-if="obj.introduction !== ''">
              <h1 class="title1">
                {{ this.$t("message.home.productDescription" /**商品描述 */) }}
              </h1>
              <div class="product-details-content-item flex" v-html="obj.introduction"></div>
            </div>
          </div>
        </div>



      </div>




      <div>
        <div class="product-details-merchant">
          <div class="product-details-merchant-top flex-start">
            <div class="shop-img">
              <img :src="$getImageUrl(store.logo)" :alt="store.type" fit="fill" />
            </div>
            <h1>{{ store.name }}</h1>
          </div>
          <!-- <div class="product-details-merchant-statistics flex-between">
            <div class="all flex-center merchant-statistics" style="width: 50%">
              <h2>{{ store.type }}</h2>
              <span>店铺类型</span>
            </div>
            <div class="line"></div>
            <div class="follower flex-center merchant-statistics" style="width: 50%">
              <h2>{{store.phone}}</h2>
              <span>{{ this.$t("message.home.followers" /**关注 */) }}</span>
            </div>
          </div> -->
          <div class="flex-center merchant-statistics">
            <h2>{{ store.phone }}</h2>
            <span>TEL</span>
          </div>
          <el-button type="primary" plain @click="gotoStroe">
            {{ this.$t("message.home.visitStore" /**访问商店 */) }}>
          </el-button>
        </div>
        <div class="titleRe" v-if="merchantGoodsList.length">
          {{ this.$t("message.home.recommendedProducts") }}
        </div>
        <div class="product-details-merchant" style="border: none; padding: 0" v-if="merchantGoodsList.length">
          <EsProductView v-for="(item) in merchantGoodsList" :key="item.id + Math.random()" :item="item" />
          <div class="no-data" v-if="!merchantGoodsList.length">
            <el-empty :description="$t('message.home.noData')"></el-empty>
          </div>
        </div>
      </div>





      <!-- <EsProductMerchant ref="recChild" /> -->
    </div>



    <div class="like" v-if="recommendGoodss.length">
      <h1 class="title">
        {{ this.$t("message.home.猜你喜欢" /**商品描述 */) }}
      </h1>
      <div class="product-details-content-item1">
        <!-- <div style="width: 166px"> -->
        <EsProductView v-for="item in recommendGoodss" :key="item.id + Math.random()" :item="item" :belike="true">
        </EsProductView>
        <!-- </div> -->
        <div class="no-data" v-if="!recommendGoodss.length">
          <el-empty :description="$t('message.home.noData')" style="width: 100%"></el-empty>
        </div>
      </div>
    </div>



    <!-- <EsProductLike ref="likeChild" /> -->
    <EsIconTips />
    <EsFooterView />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
// import EsProductInfo from "@/components/productInfo";
// import EsProductDescription from "./productDescription.vue";
// import EsProductDetailsInfo from "./productDetails.vue";
// import EsProductComment from "./productComment.vue";
// import EsProductMerchant from "./productMerchant.vue";
// import EsProductLike from "./productLike.vue";
import EsIconTips from "@/components/iconTips";
import EsProductView from "@/components/product";

//////////////////////////////////////////////////////////////////////////////////////

import {
  recommend
} from "@/api/goods/goods.js"
import {
  goods_review_list
} from "@/api/goods/review.js"
import {
  goods_consultation_list
} from "@/api/goods/consultation.js"
import {
  marketing_goods
} from "@/api/marketing/marketing.js"
import {
  hits,
  detail,
  compare_bar,
  add_compare,
  list_by_category,
  search,
} from "@/api/goods/goods.js"
import {
  get_current,
  add,
  list,
  modify,
  remove,
  clear,
} from "@/api/order/cart.js"

import {
  getCoupon
} from "@/api/marketing/coupon_code.js"

import {
  show_store_center
} from '@/api/upms/profile.js'
import {
  add as add_favorite
} from "@/api/upms/goods_favorite.js"
import { notLogin } from "@/common/pageHook";
import { addToGuestCart, getGuestCartCount } from "@/util/guestCart";
import store from "../../store";

import vuePhotoZoomPro from "vue-photo-zoom-pro";
import { ImgZoomer, ImgPreview } from "vue-photo-zoom-pro";
import "vue-photo-zoom-pro/dist/style/vue-photo-zoom-pro.css";



////////////////////////////////////////////////////////////////////



export default {
  name: "EsProductDetails",
  components: {
    // EsProductInfo,
    // EsProductDescription,
    // EsProductDetailsInfo,
    // EsProductComment,
    // EsProductMerchant,
    // EsProductLike,
    EsProductView,
    EsIconTips,
    vuePhotoZoomPro,
    ImgZoomer,
    ImgPreview,
  },
  data() {
    return {
      loading: false,
      id: "",


      itemname: process.env.VUE_APP_ITEM_NAME,
      currentIndex: 0,
      swiperOptionTop: {
        // loop: false,
        // loopedSlides: 3, // looped slides should be the same
        // spaceBetween: 10,
        centeredSlides: true,
        spaceBetween: 10,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        thumbs: {
          swiper: {
            el: ".gallery-thumbs", //定义关联的thumbs的class
            spaceBetween: 10,
            slidesPerView: "auto",
            slideToClickedSlide: true,
            watchSlidesVisibility: true,
          },
          slideThumbActiveClass: "slide-thumb-active",
        },
      },
      num: 1,
      minbuy: 1,
      goodsAttrObj: {},
      showOnlieService: false,
      // loading: false,
      isCollect: false,
      canSelectAttributes: [],
      price: null,
      curIndex: 0,
      currentSkuTitle: [],
      imgList: "",
      skuPrice: null,
      maxNum: 100,
      isIntDis: true,
      show: true,
      min: 1,
      // skuSellingPrice:0

      // loading: false,
      // itemname: process.env.VUE_APP_ITEM_NAME,
      pageNum: 1,
      // pageSize: 5,
      evaluationTypeKey: undefined,
      total: 0,
      categoryNum: {
        havePicture: {
          text: this.$t("message.home.hasImage"),
          num: "0",
          evaluationType: -2,
        },
        positiveComments: {
          text: this.$t("message.home.highOpinion"),
          num: "0",
          evaluationType: 1,
        },
        mediumReview: {
          text: this.$t("message.home.mediumOpinion"),
          num: "0",
          evaluationType: 2,
        },
        negativeComment: {
          text: this.$t("message.home.lowOpinion"),
          num: "0",
          evaluationType: 3,
        },
      },
      evaluationImages: [],
      merchantGoodsList: "",


      //////////////////////////////////////////////////////////////////////////////////////////////////

      currentPage: 1,
      // 设置加载的第几次，默认是第一次  
      pageSize: 10,
      //返回数据的个数  
      orderBy: "",
      //排序字段
      orderType: "",
      //排序 asc正 desc反
      searchLoading: false,
      //"上拉加载"的变量，默认false，隐藏  
      searchLoadingComplete: false,
      //“没有数据”的变量，默认false，隐藏 
      objsList: [],
      sizeTabsOn: 0,
      address: [],
      sizeTabs: [{
        name: 'S'
      }, {
        name: 'M'
      }, {
        name: 'L'
      }],
      // goodsId: "",
      cartSize: 0,
      imgUrls: [],
      // indicatorDots: true,
      // autoplay: true,
      // interval: 5000,
      // duration: 1000,
      circular: true,
      goodsData: [],
      proCat: [],
      thatCount: 0,
      page: 2,
      index: 2,
      brand: [],
      // 滑动
      imgUrl: [],
      kbs: [],
      lastcat: [],
      course: [],
      datas: [],
      //--
      background: ['demo-text-1', 'demo-text-2', 'demo-text-3'],
      indicatorDots: true,
      vertical: true,
      autoplay: true,
      interval: 2000,
      duration: 500,
      youhuishow: false,
      guigeshow: false,
      dizhishow: false,
      webPath: "",
      doc_doc: "",
      loadType: "load",
      formData: {
        skuId: null,
        marketingId: null,
        quantity: 1,
        currentCartId: ''
      },
      queryParams: {
        pageNumber: 0,
      },
      goodsId: '',
      skuId: '',
      obj: {},
      idxs: [],
      skuSelectedTab: '',
      skus: [],
      sku: {},
      cartQuantity: 0,
      // currentCart: [],
      marketings: [],
      coupons: [],
      store: {},
      goodsLabels: [],
      reviews: [],
      recommendGoodss: [],
      marketingModeId: null,
      seckillable: false,
      marketingId: null,
      marketingVo: null,
      showStoreCenter: false,
      notJoinGroup: false,
      nowHours: null,
      nowMinutes: null,
      nowSeconds: null,
      hours: 0, //时
      minutes: 59, //分
      seconds: 59, //秒
      countdown: '00:59:59', //倒计时
      timer: null, //重复执行

      //////////////////////////////////////////////////////////////////////////////////////////////////

    };
  },
  methods: {
    // ...mapActions("productDetails", ["requestProductDetails"]),
    ...mapMutations({ loadCartItems: "LOADCARTITEMS" }),
    async info() {
      await this.requestProductDetails({
        sellerGoodsId: this.id,
        token: localStorage.getItem(BIZ_TOKEN),
      });
    },
    mouseEnter() {
      this.$refs.swiperTop.$swiper.autoplay.stop();
    },
    mouseLeave() {
      this.$refs.swiperTop.$swiper.autoplay.start();
    },
    changeColor(index, info) {
      this.currentIndex = index;
    },
    // numberFormatFn(num) {
    //   return numberFormat(num);
    // },

    inputNumBlur() {
      // this.num = 1;
      // let maxCount = localStorage.getItem('maxBuy')
      // var pattern = /^[1-9][0-9]*$/;
      // if (!pattern.test(this.num)) {
      //   // input 框绑定的内容为空
      //   this.num = "1";
      // } else {
      //   if (this.num == undefined) {
      //     this.num = "1";
      //   }
      //   if (this.num > maxCount) {
      //     this.num = maxCount;
      //   }
      // }
    },

    ...mapActions({
      // requestProductDetails: "productDetails/requestProductDetails",
      requestCollectGoods: "user/requestCollectGoods",
      requestCollectGoodsDel: "user/requestCollectGoodsDel",
    }),
    ...mapMutations({
      updateCheckProductPay: "cart/updateCheckProductPay",

      // updateProductDetails: "productDetails/updateProductDetails",
    }),
    onSlideChange() {
      this.curIndex = this.$refs.swiperTop.$swiper.activeIndex;
    },
    change(index) {
      this.$refs.swiperTop.$swiper.slideTo(index);
      this.curIndex = index;
    },

    changeGoodAttr(attrId, valueId, index, bool) {
      const obj = { ...this.goodsAttrObj };
      obj[attrId] = valueId;
      this.goodsAttrObj = obj;
      const disAttr = new Set();
      const allGood = this.obj?.canSelectAttributes?.goodAttrs;
      const temparr = JSON.parse(JSON.stringify(this.goodsAttrObj));

      if (allGood.length === Object.keys(this.goodsAttrObj).length) {
        allGood.forEach((item, i) => {
          if (i != index) {
            item.attrValues.forEach((attr, j) => {
              temparr[item.attrId] = attr.attrValueId;
              const { skuId } = this.getAttrNameAndSkuId(true, temparr);
              if (skuId == -1) {
                disAttr.add(attr.attrValueId);
              }
            });
          }
        });
      }
      this.obj?.canSelectAttributes?.goodAttrs.forEach((item) => {
        item.attrValues.forEach((attr) => {
          attr.disabled = disAttr.has(attr.attrValueId);
        });
      });
      this.getAttrNameAndSkuId();
      !bool && this.changeGoodAttr(attrId, valueId, index, true)
    },
    getAttrNameAndSkuId(find, obj) {
      const { skus } = this.obj.canSelectAttributes ?? {};
      if (obj && "undefined" in obj) {
        delete obj[undefined];
      }
      const attrIds = find ? Object.keys(obj) : Object.keys(this.goodsAttrObj);
      const finde = find ? obj : this.goodsAttrObj;
      const sku = skus?.find((x) => {
        let length = 0;
        if (x.attrs && x.attrs.length > 0) {
          x.attrs.forEach((attr) => {
            if (
              attrIds.includes(attr.attrId) &&
              attr.attrValueId == finde[attr.attrId]
            ) {
              length += 1;
            }
          });
        }

        return length == attrIds.length;
      }) || { skuId: -1 };
      let checkAttrName = "";

      const attrs = this.obj.canSelectAttributes?.goodAttrs;
      if (attrIds.length > 0) {
        attrIds.forEach((attrId) => {
          const a = attrs.find((attr) => attr.attrId == attrId);
          const { attrValueName } = a.attrValues.find(
            (value) => value.attrValueId === this.goodsAttrObj[attrId]
          );
          checkAttrName += `${a.attrName} : ${attrValueName}   `;
        });
      }
      this.currentSkuTitle = checkAttrName.split("  ");
      this.price = sku.discountPrice || sku.sellingPrice || this.obj.price;
      this.skuPrice = sku.sellingPrice;
      this.imgList = sku?.img;
      this.isIntDis = sku.skuId == -1;
      return {
        checkAttrName,
        img: sku.img,
        skuId: sku.attrs?.length == 0 ? '-1' : sku.skuId,
        price: this.price
      };
    },

    buy() {
      //未登录
      // if (!this.isLogin) {
      //   this.$router.push("/login");
      //   this.$emit("handleBuy");
      //   return;
      // }
      // const isShelf = this.productDetails.isShelf;
      // if (!isShelf) {
      //   this.$message({
      //     type: "warning",
      //     message: this.$t("message.home.productAvailable"),
      //   });
      //   return;
      // }
      // const { skuId, checkAttrName, price } = this.getAttrNameAndSkuId();
      // const attrs = this.productDetails.canSelectAttributes?.skus;
      // const a = attrs?.find((attr) => attr.skuId == skuId);
      // const zoomImg = a?.coverImg;
      // this.updateCheckProductPay([
      //   {
      //     title: this.productDetails.name,
      //     checkList: [new Date().getTime()],
      //     checkAll: true,
      //     isIndeterminate: false,
      //     list: [
      //       {
      //         ...this.productDetails,
      //         checkTotal: this.num,
      //         skuid: skuId,
      //         checkAttrName,
      //         price,
      //         Identifier: new Date().getTime(),
      //         zoomImg: zoomImg ? zoomImg : "",
      //       },
      //     ],
      //   },
      // ]);
      this.$router.push("/settlement");
      this.$emit("handleBuy");
    },
    addCard() {
      if (this.isIntDis) {
        return;
      }
      if (notLogin()) {
        return;
      }
      // const isShelf = this.productDetails.isShelf;
      // if (!isShelf) {
      //   this.$message({
      //     type: "warning",
      //     message: this.$t("message.home.productAvailable"),
      //   });
      //   return;
      // }

      const cartItems = this.$store.state.cartItems;
      const { skuId, checkAttrName, price } = this.getAttrNameAndSkuId();
      const attrs = this.obj.canSelectAttributes?.skus;
      const a = attrs?.find((attr) => attr.skuId == skuId);
      const zoomImg = a?.coverImg;
      const count = this.num;
      const sellerName = this.obj.seller.name;
      let str1 = cartItems.some((item) => {
        if (skuId !== -1) {
          return item.skuid == skuId;
        } else {
          return item.id == this.obj.id;
        }

      });
      this.isIntDis = false
      let isSellerName = cartItems.filter((item) => item.seller.name == sellerName)

      if (str1 && isSellerName.length) {
        this.$message({
          message: this.$t(
            "message.home.addCartMessageFaild" /**添加到购物车成功 */
          ),
          type: "warning",
        });
      } else {





        cartItems.push({
          // ...this.productDetails,
          skuId: skuId,
          checkAttrName,
          zoomImg: zoomImg ? zoomImg : "",
          count,
          price,
          Identifier: new Date().getTime(),
        });
        this.$store.commit("cart/updateCartItems", cartItems);
        this.$message({
          message: this.$t(
            "message.home.addCartMessage" /**添加到购物车成功 */
          ),
          type: "success",
        });
      }
    },
    async collectEvent() {
      if (notLogin()) {
        return;
      }
      try {
        if (this.obj.isKeep === 1) {
          await this.requestCollectGoodsDel({
            sellerGoodsId: this.obj.id,
            token: localStorage.getItem(BIZ_TOKEN),
          });
          this.$message.warning(this.$t("message.home.cancelSuccess"));
          Bus.$emit("updateCollect", this.obj.id);
        } else {
          await this.requestCollectGoods({
            sellerGoodsId: this.obj.id,
            token: localStorage.getItem(BIZ_TOKEN),
          });
          this.$message.success(this.$t("message.home.collectionSuccess"));
          Bus.$emit("updateUnKeep", this.obj.id);
        }

        await this.requestProductDetails({
          sellerGoodsId: this.id,
          token: localStorage.getItem(BIZ_TOKEN),
        });
      } catch (err) { }
    },
    showServiceDialog() {
      if (notLogin()) {
        return;
      }
      const sellerId = this.store.id;
      const name = this.store.name;
      // openChatPage(
      //   this.$store.state.token,
      //   sellerId,
      //   name,
      //   this.productDetails.id
      // );
      // const prefix = config.HOST_URL + "/chat/#/pc/yellow?";
      // const suffix = `token=${
      //   this.$store.state.token
      // }&partyid=${sellerId}&name=${name}&productId=${
      //   this.productDetails.id
      // }&lang=${getCurrentLang().lang}`;

      // window.open(prefix + suffix, "_blank");

      // if (!notLogin()) {
      //   this.showOnlieService = true;
      // }

      // openChatPage(localStorage.getItem('BIZ_TOKEN'), this.productDetails.seller.id, this.productDetails.seller.name)
    },





    // subUsername(user) {
    //   if (user.indexOf("@") < 0) {
    //     let str = user.substring(2, user.length - 1);
    //     let name = user.replace(str, "***");
    //     return name;
    //   } else {
    //     let str = user.substring(1, user.indexOf("@"));
    //     let name = user.replace(str, "***");
    //     return name;
    //   }
    // },

    async requestCommend(params) {
      try {
        this.loading = true;
        params = params ?? {
          // sellerGoodsId: this.productDetails.id,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        };
        await this.requestRecommendLList(params).then((res) => {
          const { pageInfo } = res;
          this.total = pageInfo.totalElements;
        });
      } finally {
        this.loading = false;
      }
      this.genImageList();
    },

    async requestEvaluationCategory() {
      // const res = await getProductEvaluationCategory({
      //   goodId: this.productDetails.id,
      // });
      // if (res && res.code === "0") {
      //   for (let key in res.data) {
      //     this.categoryNum[key].num = res.data[key];
      //   }
      // }
    },

    genImageList() {
      this.evaluationImages = [];
      // for (let evaluation of this.productComment) {
      //   const imgUrls = Object.keys(evaluation)
      //     .filter((x) => x.includes("imgUrl") && !!evaluation[x])
      //     .map((x) => evaluation[x]);
      //   this.evaluationImages.push(imgUrls);
      //   if (evaluation.content == "") {
      //     evaluation.content = this.$t("message.home.用户未发表评论");
      //   }
      //   if (evaluation.content == "系统默认好评") {
      //     evaluation.content = this.$t("message.home.系统默认好评");
      //   }
      // }
    },

    onEvaluationClick(key) {
      this.pageNum = 0;
      this.total = 0;
      this.evaluationTypeKey = key;
      // this.requestCommend({
      //   sellerGoodsId: this.productDetails.id,
      //   pageNum: this.pageNum,
      //   pageSize: this.pageSize,
      //   evaluationType: this.categoryNum[key].evaluationType,
      // });
    },

    currentChange(page) {
      this.pageNum = page;
      this.requestCommend();
    },
    timestampToTime(timestamp) {
      timestamp = timestamp ? timestamp : null;
      let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      let h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      let s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return $formatZoneDate(Y + M + D + h + m + s);
    },
    isInteger(num) {
      if (parseInt(num, 10) === num) {
        return num + ".0";
      } else {
        return num;
      }
    },




    gotoStroe() {
      // sessionStorage.setItem("storeRefresh", true);
      this.$router.push({
        name: "store",
        query: { storeId: this.store.id },
      });
    },
    async getLike() {
      let sellerId = localStorage.getItem("sellerRecId");
      if (sellerId) {
        let res = await AlsoLike({
          type: 2,
          sellerId: sellerId,
        });
        this.merchantGoodsList = res.data.splice(0, 3);
      }

    },








    /////////////////////////////////////////////////////////////////////////////////////////////////////

    load_show_store_center() {
      show_store_center().then(response => {
        this.showStoreCenter = response.data.data.showStoreCenter;
      })
    },
    goods_detail() {
      this.loading = true;
      detail({
        "goodsId": this.goodsId,
        "skuId": this.skuId
      }).then(response => {
        let data = response.data;
        this.loading = false;
        this.obj = data.data.goods;
        this.store = data.data.store;
        this.skus = data.data.skus;
        this.reviews = data.data.reviews;
        this.goodsLabels = data.data.goodsLabels;
        this.marketings = data.data.marketings;
        this.coupons = data.data.coupons;
        if (0 <= this.obj.specificationItems && 1 == this.skus.length) {
          this.formData.skuId = this.skus[0].id;
        }
        this.defaultSkuSelect();
      }).catch(error => {
        this.loading = false;
        console.error("error", error);
        // uni.showToast({
        // 	title: this.messages['common_message_unknownError'],
        // 	duration: 2000
        // });
      })
    },
    //秒杀初始化
    seckillInit() {
      let now = new Date();
      let nowHour = now.getHours();
      this.minutes = 59 - now.getMinutes();
      this.seconds = 60 - now.getSeconds();
      this.timer = setInterval(() => {
        this.timeCount()
      }, 1000);
    },
    // 倒计时
    timeCount() {
      --this.seconds;
      if (this.seconds <= 0) {
        --this.minutes;
        this.seconds = 59;
      }
      if (this.minutes <= 0) {
        --this.hours;
        this.minutes = 59
      }
      if (this.hours < 0) {
        this.hours = 0;
        this.seconds = 59;
        this.minutes = 59;
      }
      this.countdown = this.hours + ":" + this.minutes + ":" + this.seconds;
    },
    async goods_share() {
      let spreadUserId = null;
      if (this.userInfo) {
        spreadUserId = this.userInfo.id;
      }
      let currentUrl = window.location.href;
      if (spreadUserId) {
        currentUrl = currentUrl + '&spreadUserId=' + spreadUserId
      }
      try {
        await navigator.clipboard.writeText(currentUrl);
        this.$message({
          message: '分享链接复制成功，请粘贴至分享处!',
          type: "success",
        });
      } catch (err) {
        console.log(err);
        this.$message({
          message: '分享失败!',
          type: "erroe",
        });
      }
    },
    goods_favorite_add() {
      if (this.isLogin) {
        add_favorite({
          "goodsId": this.obj.id
        }).then(response => {
          let statusCode = response.status;
          if (200 == statusCode) {
            this.$message({
              message: this.$t("message.home.collectionSuccess"),
              type: "success",
            });
          }
        }).catch(error => {
          let errResponse = JSON.parse(error.request.response ? error.request.response : '');
          if (errResponse && errResponse.message) {
            if (errResponse.message == 'shop_goodsFavorite_exist') {
              this.$message({
                message: '商品已被收藏',
                type: "success",
              });
            }
          }
        })
      } else {
        this.$message({
          message: this.$t("message.home.notLogin"),
          type: "warning",
        });
        this.$router.push("/login");
      }

    },
    goods_marketing_goods() {
      this.loading = true;
      marketing_goods({
        "goodsId": this.id,
        "marketingId": this.marketingId
      }).then(response => {
        this.loading = false;
        this.marketingVo = response.data.data;

      }).catch(error => {
        this.loading = false;
        console.error("error", error);
        // uni.showToast({
        // 	title: this.messages['common_message_unknownError'],
        // 	duration: 2000
        // });
      })
    },
    goods_recommend() {
      this.loading = true;
      recommend({
        "rankingType": "SCORE_COUNT",
        "storeId": this.store.id,
        "count": 5
      }).then(response => {
        this.loading = false;
        this.recommendGoodss = response.data.data.recommendGoodss;
      }).catch(error => {
        this.loading = false;
        console.error("error", error);
        // uni.showToast({
        // 	title: this.messages['common_message_unknownError'],
        // 	duration: 2000
        // });
      })
    },
    goods_get_coupon(index, id, code) {
      if (code) {
        return;
      }
      this.loading = true;
      getCoupon({
        'id': id
      }).then(response => {
        this.loading = false;
        let status = response.data.message;
        if (status == 'SUCCESS') {
          this.coupons[index].code = response.data.data.couponCode.code ? response.data.data
            .couponCode.code : null;
          // uni.showToast({
          // 	title: '领取成功',
          // 	duration: 2000
          // });
        }
        if (status == 'FILD') {
          // uni.showToast({
          // 	title: '已领完,领取失败！',
          // 	duration: 2000
          // });
        }
      }).catch(error => {
        this.loading = false;
        console.error("error", error);
        // uni.showToast({
        // 	title: this.messages['common_message_unknownError'],
        // 	duration: 2000
        // });
      })
    },
    goods_review_list() {
      this.loading = true;
      goods_review_list({
        'id': this.addressId
      }).then(response => {
        this.loading = false;
        this.formData = response.data.data.address;

      }).catch(error => {
        this.loading = false;
        console.error("error", error);
        // uni.showToast({
        // 	title: this.messages['common_message_unknownError'],
        // 	duration: 2000
        // });
      })
    },
    goods_consultation_list() {
      this.loading = true;
      goods_consultation_list({
        'id': this.addressId
      }).then(response => {
        this.loading = false;
        this.formData = response.data.data.address;

      }).catch(error => {
        this.loading = false;
        console.error("error", error);
        // uni.showToast({
        // 	title: this.messages['common_message_unknownError'],
        // 	duration: 2000
        // });
      })
    },
    //默认sku选中
    defaultSkuSelect: function () {
      for (let i = 0; i < this.skus.length; i++) {
        if (this.skus[i].isDefault) {
          this.sku = this.skus[i];
          this.formData.skuId = this.sku.id;
        }
      }

      for (let i = 0; i < this.obj.specificationItems.length; i++) {
        let entries = this.obj.specificationItems[i].entries;
        for (let x = 0; x < entries.length; x++) {

          if (this.sku.specificationValues[i].value == entries[x].value) {
            this.idxs[i] = x
            // this.$set(this.idxs, i, x);
          }
        }
      }
      this.goods_marketing_goods();
    },
    //颜色
    skuShowTab: function (index, idx, item) {
      // this.idxs[index]=idx
      this.$set(this.idxs, index, idx);
      this.skuSelectedTab = '';
      let selectedSpecItems = [];
      for (let i = 0; i < this.obj.specificationItems.length; i++) {
        let entries = this.obj.specificationItems[i].entries;
        for (let x = 0; x < entries.length; x++) {
          if (this.idxs[i] == x) {
            this.skuSelectedTab += entries[x].value + "  ";
            selectedSpecItems.push(entries[x]);
          }
        }
      }
      // 这做判断  skus  中  同时 包含  selectedSpecItems 的id  和 value的sku
      for (let i = 0; i < this.skus.length; i++) {
        let sku = this.skus[i];
        let isTrue = false;
        if (sku.specificationValues.length == selectedSpecItems.length) {
          for (let x = 0; x < sku.specificationValues.length; x++) {
            let specificationValue = sku.specificationValues[x];
            if (x == 0) {
              isTrue = true;
            }
            let selectedSpecItem = selectedSpecItems[x];
            if (specificationValue.id == selectedSpecItem.id && specificationValue.value ==
              selectedSpecItem.value) {
              isTrue = isTrue && true;
            } else {
              isTrue = isTrue && false;
            }
          }
          if (isTrue) {
            this.formData.skuId = sku.id;
            this.sku = sku;
            break;
          }
        }
      }
      //根据skuList  选定sku
      // 获取sku 库存,编号，价格，等信息
      //订单提交的时候sku，数量
      // 订单加入购物车的时候
      this.goods_marketing_goods();
    },
    onErrorImg(item) {
      this.$set(item, 'thumbnail', "/static/images/default_thumbnail.jpg");
      this.$set(item, 'logo', "/static/images/default_thumbnail.jpg");
    },
    //尺寸
    guanbi: function (e) {
      var that = this;
      var name = e.currentTarget.dataset.name;
      if (name == 'youhuishow') {
        that.youhuishow = false;
      }

      if (name == 'guigeshow') {
        that.guigeshow = false;
      }

      if (name == 'dizhishow') {
        that.dizhishow = false;
      }
    },
    showbox: function (e) {
      var that = this;
      var name = e.currentTarget.dataset.name;
      if (name == 'youhuishow') {
        that.youhuishow = true;
      }

      if (name == 'guigeshow') {
        that.guigeshow = true;
      }

      if (name == 'dizhishow') {
        that.dizhishow = true;
      }
    },
    cart_add_handler: function (e) {
      if (!(this.formData.skuId && this.formData.skuId.length > 0)) {
        this.$message({
          message: '请选择规格',
        });
        // if (this.guigeshow) {
        // uni.showToast({
        // 	title: "请选择规格",
        // 	duration: 2000
        // });
        // }
        // this.guigeshow = true;
      } else {
        this.cart_add();
      }
    },
    cancel_handler: function (e) {
      this.guigeshow = false;
    },
    buy_handler: function (e) {

      if (this.isLogin) {

        this.notJoinGroup = false;
        if (!(this.formData.skuId && this.formData.skuId.length > 0)) {
          $message('请选择商品规格');
          // this.guigeshow = true;
        } else {

          this.$router.push({ name: "settlement", query: { skuId: this.formData.skuId, marketingId: this.marketingId, quantity: this.formData.quantity } });
        }


      } else {
        // 游客用户：先将商品加入本地购物车，然后跳转到结算页（GuestCheckout 会处理注册）
        if (!(this.formData.skuId && this.formData.skuId.length > 0)) {
          this.$message({
            message: '请选择商品规格',
          });
          return;
        }
        addToGuestCart({
          skuId: this.formData.skuId,
          goodsId: this.goodsId,
          goodsName: this.obj.name,
          goodsImage: this.obj.thumbnail,
          skuName: this.sku.name || this.skuSelectedTab || '',
          price: Number(this.sku.price),
          quantity: this.formData.quantity,
          storeId: this.store.id,
          storeName: this.store.name,
        });
        this.$router.push({ name: "settlement", query: { skuId: this.formData.skuId, marketingId: this.marketingId, quantity: this.formData.quantity } });
      }

    },

    buy_handler_nogroup: function (e) {
      this.notJoinGroup = true;
      if (!(this.formData.skuId && this.formData.skuId.length > 0)) {
        this.guigeshow = true;
      } else {
        //购买逻辑
        // uni.navigateTo({
        // 	url: '../../order/order/checkout?skuId=' + this.formData.skuId + "&marketingId=" + this
        // 		.marketingId + '&notJoinGroup=true&quantity=' + this
        // 		.formData.quantity
        // })
      }
    },

    seckill_handler: function (e) {
      if (!(this.formData.skuId && this.formData.skuId.length > 0)) {
        this.guigeshow = true;
      } else {
        //购买逻辑
        // uni.navigateTo({
        // 	url: '../../order/order/checkout?skuId=' + this.formData.skuId + "&marketingId=" + this
        // 		.marketingId + '&quantity=' + this
        // 		.formData.quantity
        // })

      }
    },
    group_handler: function (e) {
      if (!(this.formData.skuId && this.formData.skuId.length > 0)) {
        this.guigeshow = true;
      } else {
        //购买逻辑
        // uni.navigateTo({
        // 	url: '../../order/order/checkout?skuId=' + this.formData.skuId + "&marketingId=" + this
        // 		.marketingId + '&quantity=' + this
        // 		.formData.quantity
        // })
      }
    },
    exchange_handler: function (e) {
      if (!(this.formData.skuId && this.formData.skuId.length > 0)) {
        this.guigeshow = true;
      } else {
        //购买逻辑
        // uni.navigateTo({
        // 	url: '../../order/order/checkout?skuId=' + this.formData.skuId + "&marketingId=" + this
        // 		.marketingId + '&orderType=EXCHANGE&quantity=' + this
        // 		.formData.quantity
        // })
      }
    },
    cart_add: function (e) {
      this.loading = true
      if (this.isLogin) {
        //添加到购物车
        this.loading = true;
        add(this.formData).then(response => {
          this.loading = false;
          let currentCart = response.data.data.currentCart;
          if (currentCart) {

            this.cartQuantity = response.data.data.quantity;
            this.formData.currentCartId = currentCart.id;

            this.$store.commit("SETCURRENTCART", currentCart);
            this.loadCartItems();
          }
        }).catch(error => {
          this.loading = false;
          console.error("error", error);
        })
      } else {
        // 游客模式：添加到本地购物车
        this.loading = false;
        addToGuestCart({
          skuId: this.formData.skuId,
          goodsId: this.goodsId,
          goodsName: this.obj.name,
          goodsImage: this.obj.thumbnail,
          skuName: this.sku.name || this.skuSelectedTab || '',
          price: Number(this.sku.price),
          quantity: this.formData.quantity,
          storeId: this.store.id,
          storeName: this.store.name,
        });
        this.$message({
          message: this.$t("message.home.addCartMessage") || 'Added to cart successfully',
          type: "success",
        });
      }
    },

    bindMinus: function () {
      this.formData.quantity -= 1;
    },
    bindPlus: function () {
      this.formData.quantity += 1;
    },



    //////////////////////////////////////////////////////////////////////////////////////////////////



    //////////////////////////////////////////////////////////////////////////////////////////////////



  },
  computed: {

    ...mapGetters(["currentCart"]),
    ...mapGetters({ islogin: "isLogin" }),

    // ...mapGetters("productDetails", [
    //   "productDetails",
    // "productComment",
    // "productCommentPageInfo",
    // "productCommentNum",
    // ]),

    // ...mapGetters({
    // productDetails: "productDetails/productDetails",
    // }),
    // ...mapGetters(["isLogin"]),

    // ...mapGetters({
    //   productDetails: "productDetails/productDetails",
    // }),
    // ...mapGetters(["isLogin"]),
    // totalPrice() {
    //   if (this.price) {
    //     return this.$big(this.num).times(this.price);
    //   } else {
    //     return 
    //     numberFormat(
    //       this.$big(this.num).times(
    //         this.productDetails.discountPrice ??
    //           this.productDetails.sellingPrice ??
    //           0
    //       )
    //     );
    //   }
    // },
    ...mapGetters({
      userInfo: "userInfo",
      isLogin: "isLogin",
    }),
    productImgs() {
      return null;
      // return new Array(10)
      //   .fill("")
      //   .map((_, index) => this.productDetails[`imgUrl${index + 1}`])
      //   .filter((item) => !!item);
    }




  },
  async mounted() {

    const currentRouter = this.$router.currentRoute;
    if (currentRouter.query.spreadUserId) {
      localStorage.setItem("spreadUserId", currentRouter.query.spreadUserId);
    }



    // const currentRouter = this.$router.currentRoute;
    // this.id = currentRouter.query.id;
    // if (!this.id) {
    //   // this.$router.replace("/");
    //   return;
    // }
    // try {
    //   this.loading = true;
    //   await this.requestProductDetails({
    //     sellerGoodsId: this.id,
    //   });
    // } finally {
    //   this.loading = false;
    //   localStorage.setItem("sellerId", this.productDetails.seller.id);
    //   localStorage.setItem("sellerRecId", this.productDetails.seller.id);
    //   if (this.isLogin) {
    //     this.$refs.recChild.getLike();
    //     this.$refs.likeChild.getLike();
    //   }
    //   if (!this.productDetails.id) {
    //     // this.$message({
    //     //   message: this.$t("message.home.switchLang"),
    //     // });
    //     // this.$router.replace("/");
    //   }
    // }

    // const currentRouter = this.$router.currentRoute;
    this.goodsId = currentRouter.query.id ? currentRouter.query.id : null;
    this.skuId = currentRouter.query.skuId ? currentRouter.query.skuId : null;
    this.goods_detail();
    this.goods_recommend(); //推荐
    if (this.marketingId) {
      this.goods_marketing_goods();
    }
    this.formData.currentCartId = this.$store.state.currentCart ? this.$store.state.currentCart.id : null;
    this.load_show_store_center();
    this.seckillInit();

  },
  beforeRouterUpdate(to, from, next) { },
  watch: {
    $route: function (to, from) {
      if (to) {
        localStorage.removeItem("sellerId");
        localStorage.removeItem("sellerRecId");
        location.reload();
      }
    },
  },
};
</script>

<style lang="scss">
.contain {
  display: flex;
}

.product-details {
  &-contain {
    align-items: flex-start;
  }

  &-bottom {
    max-width: 1000px;
    margin: 52px auto 107px auto;

    &-item {
      flex-direction: column;
    }

    span {
      font-weight: 500;
      font-size: 12px;
      margin-top: 15px;
    }
  }
}



html[dir="rtl"] {
  .product-info-right-info-des-item div:first-child {
    margin-right: 0 !important;
  }

  .product-info-left {
    margin-right: 0 !important;
    margin-left: 22px !important;
  }

  .product-details-merchant,
  .titleRe {
    margin-right: 17px;
    margin-left: 0;
  }

  .product-details-merchant-top h1 {
    margin-right: 10px;
    margin-left: 0;
  }

  .product-info-right-info-price h2 {
    padding-right: 0;
    padding-left: 8px;
  }

  .product-info-right-info-tool-item {
    margin-right: 0;
    margin-left: 30px;

    span {
      margin-right: 6px;
      margin-left: 0;
    }
  }

  .product-info-right-info-des {
    .label-title {
      margin-right: 0;
    }

    .el-select {
      width: 200px;
    }

    .product-attr {
      align-items: flex-start !important;
    }
  }

  .sku-titile {
    display: inline-block;
    text-align: right;
    width: 100%;
  }

}

.product-info {
  margin-top: 3px;

  &-content {
    align-items: flex-start;
  }

  &-left {
    width: 378px;
    margin-right: 22px;

    .gallery-top {
      width: 378px;
      height: 378px;
      border: 1px solid var(--color-border);
      border-radius: 4px;

      .swiper-slide {
        width: 378px;
        height: 378px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        padding: 10px;

        img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }
      }
    }

    .selector {
      z-index: 2 !important;
    }

    .out-zoomer {
      z-index: 8 !important;
      background: #fff;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .gallery-thumbs {
      height: 89px;
      margin-top: 15px;

      .swiper-slide {
        width: 87px;
        height: 89px;
        border: 1px solid var(--color-border);
        box-sizing: border-box;
        border-radius: 4px;
        padding: 5px;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
          max-width: 87px;
          object-fit: cover;
        }
      }

      .active {
        border: 1px solid var(--color-main);
      }

      .slide-thumb-active {
        border-color: var(--color-main) !important;
        border-width: 2px !important;
      }

      // .swiper-slide-active {
      //   // opacity: 1;
      // }
    }
  }

  &-right {
    width: 563px;

    &-title {
      font-weight: 600;
      font-size: 20px;
      line-height: 30px;
      color: var(--color-black);
      margin-bottom: 14px;
      word-break: break-all;
    }

    &-info {
      &-top {
        width: 100%;
        padding: 18px 0;
        border-top: 1px solid var(--color-border);
        border-bottom: 1px solid var(--color-border);
      }

      &-price {
        h2 {
          min-width: 10px;
          text-align: left;
          font-weight: 400;
          font-size: 12px;
          color: var(--color-subtitle);
          padding-right: 8px;
        }

        &.del {
          text-decoration: line-through;

          h2 {
            width: auto;
            min-width: 10px;
            padding-right: 2px;
          }

          .price {
            font-size: 14px;
            color: var(--color-price);
          }
        }
      }

      &-tool {
        &-item {
          cursor: pointer;
          margin-right: 30px;

          &:last-child {
            margin-right: 0;
          }

          span {
            color: var(--color-title);
            margin-left: 6px;
          }

          .el-icon-star-off {
            font-size: 18px;
            color: var(--color-main);
          }

          .el-icon-star-on {
            font-size: 18px;
            color: var(--color-main);
          }
        }
      }

      &-des {
        font-weight: 400;
        font-size: 12px;
        color: var(--color-subtitle);

        &-item {
          margin-top: 25px;

          // div:first-child {
          //   margin-right: 20px;
          // }
        }

        .del-line {
          text-decoration: line-through;
          margin-left: 27px;
        }

        .label-title {
          display: inline-block;
          min-width: 67px;
          margin-right: 16px;
        }

        .product-attr {
          flex-direction: column;
          align-items: baseline !important;

          .label-title {
            margin-bottom: 10px;
          }
        }

        .attr-container {
          width: 100%;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(54px, 54px));
          grid-column-gap: 10px;
          grid-row-gap: 5px;
          align-content: center;
          padding-bottom: 4px;
        }

        .active {
          border: 1px solid var(--color-main);

          border-radius: 4px;

          .attr-img {
            border: none !important;
          }
        }

        .disabled {
          opacity: 0.5;
          // cursor: not-allowed;
          border: 1px dashed #e6e6e6;
          cursor: no-drop !important;

          .attr-img {
            border: none !important;
            -webkit-filter: grayscale(100%);
            -moz-filter: grayscale(100%);
            -ms-filter: grayscale(100%);
            -o-filter: grayscale(100%);
            filter: grayscale(100%);
            filter: gray;
          }
        }

        .attr-item {
          // width: 100%;
          // display: flex;
          // flex-wrap: wrap;
          margin-right: 0 !important;
          cursor: pointer;

          .attr-img {
            // width: 54px;
            height: 34px;
            padding: 5px;
            border-radius: 4px;
            border: 1px solid var(--color-border);

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }

      &-buy {
        width: 100%;
        text-align: center;
        margin-top: 72px;
        margin-bottom: 40px;
        display: flex;
        justify-content: space-between;

        .el-button {
          width: 45%;
          max-width: 570px;
          height: 44px;
          font-weight: 700;
          font-size: 14px;
          padding: 0;
        }

        .addcart {
          width: 45%;
          max-width: 570px;
          height: 44px;
          font-weight: 700;
          font-size: 14px;
          padding: 0;
          justify-content: center;
          color: var(--color-main);
          background: linear-gradient(0deg, #fff7ec, #fff7ec), #eeeeee;
          border: 1px solid var(--color-main);
          border-radius: 4px;
          cursor: pointer;
          will-change: filter;
          transition: filter 500ms;

          &:hover {
            filter: drop-shadow(0 0 4px var(--color-main));
            // color: var();
          }
        }
      }

      .price {
        font-weight: 500;
        font-size: 16px;
        color: var(--color-price);
      }
    }
  }
}

.freight-tips {
  display: flex;
  align-items: center;

  i {
    margin-left: 10px;
    cursor: pointer;
    font-size: 16px;

    &:hover {
      color: #000;
    }
  }
}

.disBtn {
  opacity: .5;
  cursor: no-drop !important;
}













.product-details-content {
  border: 1px solid var(--color-border);
  padding: 20px 6px;
  margin-top: 28px;
}

.product-description {
  width: 957px;
  border: 1px solid var(--color-border);
  padding: 20px 0;
  margin-bottom: 28px;

  .title1 {
    font-weight: 600;
    font-size: 20px;
    color: var(--color-title);
    border-bottom: 1px solid var(--color-border);
    padding: 0 37px 19px 55px;
    margin-left: 0 !important;
  }

  p {
    font-weight: 400;
    font-size: 12px;
    color: var(--color-title);
    padding: 25px 40px;
    line-height: 17px;
  }
}

.product-details-content-item img {
  max-width: 100% !important;
}

.product-details-content-item .aplus-v2 {
  max-width: 100% !important;
}

.product-details-content-item p {
  display: flex;
  flex-direction: column;
}







.product-comment {
  border: 1px solid var(--color-border);
  width: 957px;

  .product-comment-text {
    display: -webkit-box;
  }

  .button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px 10px;
    // height: 28px;
    border-radius: 14px;
    color: #999999;
    margin-right: 13px;
    cursor: pointer;
    background: #eeeeee;

    &.active {
      color: #ffffff;
      // border: 1px solid var(--color-main);
      background: var(--color-main);
    }
  }

  .evaluation-img {
    width: 87px;
    height: 87px;
    border: 1px solid #eeeeee;
    border-radius: 4px;
    margin-right: 10px;
  }

  .p-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    height: 70px;
    padding-left: 37px;
    padding-right: 16px;
    // padding-bottom: 30px;
    // background-color: #eee;
  }

  .title1 {
    font-weight: 600;
    font-size: 20px;
    color: var(--color-title);
    margin-left: 22px;
    // border-bottom: 1px solid var(--color-border);
    // padding: 20px 37px 19px 37px;
  }

  &-item {
    padding: 15px 40px;
    border-bottom: 1px solid #eee;
  }

  &-top {
    font-size: 12px;
    justify-content: space-between;

    .userInfo {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 12px;
      color: var(-color-black);
      margin-bottom: 4px;

      img {
        width: 31px;
        height: 31px;
        object-fit: cover;
        border-radius: 100%;
        margin-right: 8px;
      }

      span {
        color: var(--color-subtitle);
      }
    }
  }

  .rate {
    .rate-box {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #000;
    }
  }

  .eval-time {
    font-size: 12px;
    color: #999999;
    margin-top: 10px;
    display: inline-block;
  }

  &-text {
    font-weight: 400;
    font-size: 16px;
    padding: 10px 0;
    color: var(-color-black);
    display: inherit !important;
    word-wrap: break-word;
  }

  &-pagination {
    width: 100%;
    text-align: center;
    padding: 40px 0;
  }

  .attrbox {
    display: flex;
    font-size: 12px;
    color: #333;

    .attr {
      &:nth-child(2) {
        margin-left: 5px;
        padding-left: 5px;
        border-left: 1px solid #999;
      }
    }
  }
}



.product-details {
  .product-details-merchant-top {
    align-items: center;

    .shop-img {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 46px;
      height: 46px;

      img {
        border-radius: 50%;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  &-merchant {
    margin-left: 17px;
    border: 1px solid var(--color-border);
    border-radius: 4px;
    padding: 10px;

    &-top {
      padding-bottom: 17px;

      img {
        width: 46px;
        height: 30px;
        object-fit: cover;
      }

      h1 {
        max-width: 130px;
        font-size: 14px;
        line-height: 16px;
        color: var(--color-black);
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        padding: 0 0 0 8px;
      }
    }

    &-statistics {
      border-top: 1px solid var(--color-border);
      border-bottom: 1px solid var(--color-border);
    }

    .line {
      width: 1px;
      height: 18px;
      background-color: var(--color-border);
    }

    .merchant-statistics {
      flex-direction: column;
      padding: 16px 0;

      h2 {
        font-weight: 700;
        font-size: 14px;
        color: var(--color-title);
        margin-bottom: 5px;
      }

      span {
        font-weight: 400;
        font-size: 12px;
        color: var(--color-title);
      }
    }

    .el-button {
      margin-bottom: 15px;
      width: 192px;
      height: 26px;
      padding: 0;
      font-size: 12px;
      font-weight: 400;
      border-radius: 27px;
    }
  }
}

.titleRe {
  padding: 18px 0;
  margin-left: 17px;
  font-weight: 400;
  font-size: 14px;
}

.product {
  margin-bottom: 10px;
}

.like {
  width: 1200px;
  margin: 0 auto;
}

.title {
  font-weight: 600;
  font-size: 20px;
  color: var(--color-title);
  margin-bottom: 10px;
  margin-top: 38px;
  margin-left: 0 !important;
}

.product-details-content-item1 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(185px, 165px));
  grid-column-gap: 15px;
  grid-row-gap: 12px;
  align-content: center;
}
</style>
